export function getLabel(id, collection) {
    const defaultLabel = collection && collection[0] ? collection[0].label : '';
    if (!id) {
        return defaultLabel;
    }
    const productType = collection.find((x) => x.value == id);
    return productType ? productType.label : defaultLabel;
}

export function byLabelSorter(a, b) {
    return a.label.localeCompare(b.label);
}
